// extracted by mini-css-extract-plugin
export var card = "StrapiPricingPlan-module--card--17bf1";
export var columns = "StrapiPricingPlan-module--columns--9e431";
export var columnsWrapper = "StrapiPricingPlan-module--columns-wrapper--62dd9";
export var heading = "StrapiPricingPlan-module--heading--2c5e4";
export var highlighted = "StrapiPricingPlan-module--highlighted--dddf3";
export var root = "StrapiPricingPlan-module--root--afa2c";